import { Button } from "components/Button/Button"
import { Modal } from "components/Modal/Modal"
import { useNotification } from "components/Notification/Notification"
import { useDisclosure } from "hooks/useDisclosure"
import { Escalation } from "interface/escalation"
import { useUpdateEscalationStatus } from "services/escalations"
import { GENERIC_ERROR_MESSAGE } from "utils/constants"

export function CloseEscalation({
	escalation: { id, status, activity },
}: {
	escalation: Escalation
}) {
	const { notify } = useNotification()
	const disclose = useDisclosure()
	const isOpen = status === "OPEN"
	const hasResponses = activity.some(({ type }) => type === "commented")
	const updateStatus = useUpdateEscalationStatus(id)
	const handleUpdate = (status: Escalation["status"]) => {
		updateStatus.mutate(
			{ status },
			{
				onSuccess: disclose.close,
				onError: (error) =>
					notify.error({ message: error.message ?? GENERIC_ERROR_MESSAGE }),
			},
		)
	}
	const handleClose = () => {
		if (!hasResponses) {
			disclose.open()
			return
		}
		handleUpdate("CLOSED")
	}
	const handleReopen = () => {
		handleUpdate("OPEN")
	}

	return (
		<>
			<Button
				type="primary"
				loading={updateStatus.isPending}
				onClick={isOpen ? handleClose : handleReopen}
			>
				{isOpen ? "Close escalation" : "Re-open escalation"}
			</Button>

			{disclose.isOpen && (
				<Modal
					open
					okText="Okay"
					title="Can’t close without response"
					classNames={{ body: "flex flex-col gap-2" }}
					cancelButtonProps={{ className: "hidden" }}
					onOk={disclose.close}
					onCancel={disclose.close}
				>
					This escalation hasn’t received a written response yet. To understand
					if and how this escalation was taken care of, we require at least one
					response.
				</Modal>
			)}
		</>
	)
}
